import UISpinner from './UISpinner'
export default UISpinner
